var React = require('react');

function IconArrowBottom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#666;}")),React.createElement("path",{"className":"a","d":"M20,5.5,12,0V4H0V7H12v4Z","transform":"translate(11) rotate(90)","key":1})]);
}

IconArrowBottom.defaultProps = {"width":"11","height":"20","viewBox":"0 0 11 20"};

module.exports = IconArrowBottom;

IconArrowBottom.default = IconArrowBottom;
